import {ItemPickersContextProvider} from '@github-ui/item-picker-base/ItemPickersContext'
import {SubIssueStateProvider} from '@github-ui/sub-issues/SubIssueStateContext'
import type {ReactNode} from 'react'

import {InputElementActiveContextProvider} from './InputElementActiveContext'
import {IssueViewerCommentsContextProvider} from './IssueViewerCommentsContext'

type IssueViewerContextProviderType = {
  children: ReactNode
}

export function IssueViewerContextProvider({children}: IssueViewerContextProviderType) {
  return (
    <IssueViewerCommentsContextProvider>
      <ItemPickersContextProvider>
        <InputElementActiveContextProvider>
          <SubIssueStateProvider>{children}</SubIssueStateProvider>
        </InputElementActiveContextProvider>
      </ItemPickersContextProvider>
    </IssueViewerCommentsContextProvider>
  )
}
